import PageHeader from "../components/common/PageHeader";
import GoToTop from "../helpers/GoToTop";
import MetaData from "../helpers/MetaData";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { useRef, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import notification from "../helpers/notification";
import ApiService from "../api/ApiService";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import parse from "html-react-parser";
import { useCallback } from "react";
import { Modal } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

const MsKmCampaign = ({ customSlug = "makar-kumbh" }) => {
    const navigate = useNavigate();
    const params = useParams();
    const slug = params.slug || customSlug;
    const path = window.location.pathname;
    const updatedPath = path.replace(/^\//, ""); // Removes the leading slash
    localStorage.setItem("tracking_campaign_makarkumbh", updatedPath);
    const slider1 = useRef();
    const slider2 = useRef();
    const foodSliderRef = useRef();
    const ref = useRef();
    const articleRef = useRef();
    const pricingTableRef = useRef();

    const [loading, setLoading] = useState(true);
    const [campaign, setCampaign] = useState(null);
    const [isTrackingCampaign, setIsTrackingCampaign] = useState(false);
    const [trackingCampaign, setTrackingCampaign] = useState(null);
    const [top, setTop] = useState(0);
    const [isDisabled, setIsDisabled] = useState();
    const [isChecked, setIsChecked] = useState();
    const [reset, setReset] = useState();
    const [meta, setMeta] = useState(null);
    const [makarSelectedValues, setMakarSelectedValues] = useState([]);
    const [makarSelectedSeva, setMakarSelectedSeva] = useState([]);
    const [kumbhSelectedValues, setKumbhSelectedValues] = useState([]);
    const [kumbhselectedSeva, setKumbhSelectedSeva] = useState([]);
    const [makaraAnyamount, setMakaraAnyamount] = useState(0);
    const [kumbAnyamount, setKumbAnyamount] = useState(0);
    // const [anyamount, setAnyamount] = useState(0);
    const [readMore, setReadMore] = useState(false);
    const [popUpContent, setPopUpContent] = useState(null);
    const [multisevatyp, setMultiType] = useState("kumbh-makar");
    const [banksDetails, setBankDetails] = useState([]);
    const [makarArray, setMakarArray] = useState([]);
    const [kumbArray, setKumbhArray] = useState([]);

    const fetchCampaign = async () => {
        try {
            let { campaign, isTrackingCampaign } = await ApiService.fetchCampaign(slug);

            if (campaign) {
                // if(campaign.trackingType === "any_link") {
                //   localStorage.setItem("tracking_campaign", campaign?._id);
                //   // Redirect
                //   window.location.href = campaign.anyLinkUrl;
                // }

                if (isTrackingCampaign) {
                    setCampaign(campaign?.campaign);
                    setTrackingCampaign(campaign);
                    localStorage.setItem("tracking_campaign", campaign?._id);
                } else {
                    setCampaign(campaign);
                    const midpoint = campaign?.donateBtns.length / 2;
                    const makarArray = campaign?.donateBtns.slice(0, midpoint);
                    const kumbArray = campaign?.donateBtns.slice(midpoint);
                    setMakarArray(makarArray);
                    setKumbhArray(kumbArray);
                }
                setIsTrackingCampaign(isTrackingCampaign);
            } else {
                navigate("/404");
            }
        } catch (error) {
            console.log(error);
            notification("error", "Could not fetch campaign at this moment! Please try again later.");
        }
    };

    const fetchMeta = async (pagename) => {
        try {
            let res = await ApiService.fetchMetaData(pagename);
            setMeta(res);
        } catch (error) {
            console.log(error);
        }
    };

    const campaignRef = useCallback((node) => {
        if (node) {
            let headerHeight;
            if (window.innerWidth > 991) {
                headerHeight = 110;
            } else if (window.innerWidth > 576) {
                headerHeight = 80;
            } else {
                headerHeight = 73;
            }
            setTop(node?.offsetTop - headerHeight);
        }
    }, []);

    const copyToClipBoard = (text, msg) => {
        navigator.clipboard.writeText(text);
        notification("success", msg);
    };

    const handleScroll = () => {
        pricingTableRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const handleReadMore = (data) => {
        setPopUpContent(data);
        setReadMore(true);
    };

    const makarHandleCheckboxChange = (event) => {
        const value = event.target.value;
        const Idvalue = event.target.name;
        if (event.target.checked) {
            setMakarSelectedValues((prevValues) => [...prevValues, value]);
            setMakarSelectedSeva((prevIdValues) => [...prevIdValues, Idvalue]);
            setReset("");
        } else {
            setMakarSelectedValues((prevValues) => prevValues.filter((item) => item !== value));
            setMakarSelectedSeva((prevIdValues) => prevIdValues.filter((item) => item !== Idvalue));
            setReset("");
        }
    };

    const kumbhHandleCheckboxChange = (event) => {
        const value = event.target.value;
        const Idvalue = event.target.name;
        if (event.target.checked) {
            setKumbhSelectedValues((prevValues) => [...prevValues, value]);
            setKumbhSelectedSeva((prevIdValues) => [...prevIdValues, Idvalue]);
            setReset("");
        } else {
            setKumbhSelectedValues((prevValues) => prevValues.filter((item) => item !== value));
            setKumbhSelectedSeva((prevIdValues) => prevIdValues.filter((item) => item !== Idvalue));
            setReset("");
        }
    };

    const values = [...makarSelectedValues, ...kumbhSelectedValues];
    const sum = values.length > 0 ? values.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue), 0) : 0;
    localStorage.setItem("multiplesevaPrice", values);
    localStorage.setItem("multiplesevaName", [...makarSelectedSeva, ...kumbhselectedSeva]);

    const handelAnyAmount = (e) => {
        setReset("1");
        setIsChecked(false);
        setIsDisabled(true);
        setMakarSelectedSeva([]);
        setKumbhSelectedValues([]);
        if (Number(makaraAnyamount) + Number(kumbAnyamount) == 0) {
            setReset("");
            setIsChecked();
            setIsDisabled(false);
        }
    };

    const makaraDonanyamount = (e) => {
        setMakaraAnyamount(e.target.value);
    };

    const kumbDonanyamount = (e) => {
        setKumbAnyamount(e.target.value);
    };

    localStorage.removeItem("SpecialOccassionAmount");

    const multisevbtn = () => {
        localStorage.setItem("multipleseva", values);
        localStorage.setItem("SpecialOccassionAmount", sum);
        localStorage.setItem("multiplesevatype", multisevatyp);
        const sp = localStorage.getItem("SpecialOccassionAmount");
        if (sp > 0) {
            navigate(`/donation-form/${slug}`);
        } else {
            notification("error", "Please Select Multiple Seva");
        }
    };

    const donanybtn = () => {
        const anyamount = Number(makaraAnyamount) + Number(kumbAnyamount);

        localStorage.setItem("multiplesevatype", multisevatyp);
        localStorage.setItem("SpecialOccassionAmount", anyamount);
        const dam = localStorage.getItem("SpecialOccassionAmount");
        if (dam > 0) {
            localStorage.setItem("multiplesevaName", "Special Occassion");
            navigate(`/donation-form/${slug}`);
        } else {
            notification("error", "Please Enter Amount");
        }
    };

    const fetchBankDetailsData = async () => {
        try {
            const res = await ApiService.fetchBankDetailsData();
            //setBankDetails(res.banks);
            console.log(res);
            const filteredBanks_common = res.banks.filter((bank) => bank.slug === "All");
            const filteredBanks_common_length = res.banks.filter((bank) => bank.slug === "All").length;
            const filteredBanks = res.banks.filter((bank) => bank.slug == slug);
            const filteredBanks_length = res.banks.filter((bank) => bank.slug == slug).length;

            if (filteredBanks_length > 0) {
                setBankDetails(filteredBanks);
            } else {
                setBankDetails(filteredBanks_common);
            }

            // console.log(filteredBanks_common)
            // console.log(filteredBanks_common_length)
            // console.log(filteredBanks)
            // console.log(filteredBanks_length)
        } catch (err) {
            console.log(err);
            notification("error", err.response.data.message);
        }
    };

    // useEffect(() => {
    //   const loaderTimeout = setTimeout(() => setLoading(false), 1500);
    //   return () => clearTimeout(loaderTimeout)
    // }, []);

    useEffect(() => {
        if (!loading) {
            if (slider1 && slider2) {
                slider1.current?.sync(slider2.current?.splide);
            }
        }
    }, [slider1, slider2, campaign, loading]);

    useEffect(() => {
        if (campaign) {
            fetchMeta(campaign?.slug);
            setLoading(false);
        }
    }, [campaign]);

    useEffect(() => {
        fetchBankDetailsData();
    }, []);

    useEffect(() => {
        fetchCampaign();
    }, [slug]);

    return (
        <>
            <MetaData meta={meta} />
            <PageHeader
                title={loading ? "" : "Makar Sankranti and Kumbh Annadaan"}
                imgSrc={
                    campaign?.banner
                        ? `${process.env.REACT_APP_S3_URL}/uploads/campaigns/banners/${campaign.banner}`
                        : `${process.env.REACT_APP_S3_URL}/uploads/campaigns/payment-form-images/${campaign?.paymentFormImage}`
                }
            />

            <section className="campaign-heading-sec py-5" ref={campaignRef}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            {loading ? (
                                <>
                                    <Skeleton height={28} />
                                    <div className="text-center pb-md-4 pb-3">
                                        <Skeleton height={28} width={"50%"} className="mt-2" />
                                    </div>
                                </>
                            ) : (
                                <div className="heading mx-auto">
                                    <h2 className="pb-md-4 pb-3">
                                        {parse(campaign?.ctaText.split("|")[0])}
                                        <span>{campaign?.ctaText.split("|")[1] ? parse(campaign?.ctaText.split("|")[1]) : ""}</span>
                                    </h2>
                                </div>
                            )}

                            {campaign?.showCampaignImage && (
                                <figure className="mb-0">
                                    {loading ? (
                                        <Skeleton height={270} />
                                    ) : (
                                        <img
                                            className="w-100"
                                            src={`${process.env.REACT_APP_S3_URL}/uploads/campaigns/campaign-images/${campaign?.campaignImage}`}
                                            alt="Campaign image"
                                        />
                                    )}
                                </figure>
                            )}
                        </div>
                        {/* coursauel slider start*/}
                        {campaign?.showCampmultiImages && (
                            <div className="col-lg-10 mx-auto">
                                <Splide
                                    ref={ref}
                                    options={{
                                        perPage: 1,
                                        type: "loop",
                                        perMove: 1,
                                        //focus: 'center',
                                        gap: 10,
                                        arrows: false,
                                        pagination: false,
                                        autoplay: true,
                                        speed: 1000,
                                        interval: 5000,
                                    }}
                                >
                                    <>
                                        {campaign.campmultiImages.map((image, i) => (
                                            <SplideSlide key={i}>
                                                <div className="card-bg mt-3">
                                                    <img className="w-100" src={`${process.env.REACT_APP_S3_URL}/uploads/campaigns/gallery-multi-images/${image}`} alt="" />
                                                </div>
                                            </SplideSlide>
                                        ))}
                                    </>
                                </Splide>
                            </div>
                        )}
                        {/* coursauel slider  end*/}
                    </div>
                </div>
            </section>

            {campaign && !loading && (
                <>
                    <section className="campaign-main-sec py-5 mb-5">
                        <div className="container">
                            <div className="row mb-4">
                                {campaign?.seva === "multipleseva" ? (
                                    <div className="col-lg-10 mx-auto">
                                        <div className="heading">
                                            <h2 className="head-1 text-uppercase">SEVA OPPORTUNITY</h2>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="col-lg-10 mx-auto">
                                        <div className="heading">
                                            <h2 className="head-1 text-uppercase">{campaign?.sectionHeading}</h2>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="row align-item-center">
                                <div className="col-lg-6 col-xl-6 mb-lg-1 mt-3 mb-2">
                                    <h3 className="text-center">MAKAR SANKRANTI ANNADAAN</h3>
                                    <div className="donate-bars-wrap">
                                        {makarArray.map((item, i) => (
                                            <div
                                                key={i}
                                                className="donate-bar mt-0"
                                                style={{
                                                    height: `calc(100% / ${makarArray.length + 1})`,
                                                }}
                                            >
                                                <div className="first">
                                                    <h4>{item.title}</h4>
                                                </div>
                                                <div className="mid">
                                                    <span>{item.amount.toLocaleString("en-IN", { maximumFractionDigits: 0, style: "currency", currency: "INR" })}</span>
                                                </div>
                                                {/* <div className="last">
                                                    <a class="custom-btn-cls box-hover w-100 h-100">
                                                        select&nbsp;&nbsp;
                                                        <input
                                                            type="checkbox"
                                                            disabled={isDisabled}
                                                            checked={isChecked}
                                                            onChange={makarHandleCheckboxChange}
                                                            name={item.title}
                                                            id={item.title}
                                                            value={item.amount}
                                                        />
                                                    </a>
                                                </div> */}
                                                <div className="last">
                                                    <label className="custom-btn-cls box-hover w-100 h-100" style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                        <span>Select</span>
                                                        <input
                                                            type="checkbox"
                                                            disabled={isDisabled}
                                                            checked={isChecked}
                                                            onChange={makarHandleCheckboxChange}
                                                            name={item.title}
                                                            id={item.title}
                                                            value={item.amount}
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                        <div
                                            className="donate-bar mt-0"
                                            style={{
                                                height: `calc(12%)`,
                                            }}
                                        >
                                            <div className="first">
                                                <h4>Donate any amount</h4>
                                            </div>
                                            <div className="mid">
                                                <input
                                                    type="text"
                                                    onKeyUp={handelAnyAmount}
                                                    onChange={makaraDonanyamount}
                                                    id="manyAmount"
                                                    name="manyAmount"
                                                    placeholder="₹ Amount"
                                                />
                                            </div>
                                            <div className="last">
                                                {/* <a href="#" onClick={donanybtn} class="custom-btn-cls box-hover w-100 h-100">
                          <svg className="me-2" width="24" height="24" viewBox="0 0 512 512">
                            <g id="#000000ff">
                              <path
                                fill="#fff"
                                opacity="1.00"
                                d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                              ></path>
                              <path
                                fill="#fff"
                                opacity="1.00"
                                d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                              ></path>
                            </g>
                          </svg>
                          &nbsp;&nbsp; Donate
                        </a> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-xl-6 mb-lg-1 mt-3 mb-2">
                                    <h3 className="text-center">KUMBH MELA ANNADAAN</h3>
                                    <div className="donate-bars-wrap">
                                        {kumbArray.map((item, i) => (
                                            <div
                                                key={i}
                                                className="donate-bar mt-0"
                                                style={{
                                                    height: `calc(100% / ${kumbArray.length + 1})`,
                                                }}
                                            >
                                                <div className="first">
                                                    <h4>{item.title}</h4>
                                                </div>
                                                <div className="mid">
                                                    <span>{item.amount.toLocaleString("en-IN", { maximumFractionDigits: 0, style: "currency", currency: "INR" })}</span>
                                                </div>

                                                <div className="last">
                                                    <label className="custom-btn-cls box-hover w-100 h-100" style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                        <span>Select</span>
                                                        <input
                                                            type="checkbox"
                                                            disabled={isDisabled}
                                                            checked={isChecked}
                                                            onChange={kumbhHandleCheckboxChange}
                                                            name={item.title}
                                                            id={item.title}
                                                            value={item.amount}
                                                        />
                                                    </label>
                                                </div>
                                                {/* <div className="last">
                                                    <a class="custom-btn-cls box-hover w-100 h-100">
                                                        select&nbsp;&nbsp;
                                                        <input
                                                            type="checkbox"
                                                            disabled={isDisabled}
                                                            checked={isChecked}
                                                            onChange={kumbhHandleCheckboxChange}
                                                            name={item.title}
                                                            id={item.title}
                                                            value={item.amount}
                                                        />
                                                    </a>
                                                </div> */}
                                            </div>
                                        ))}
                                        <div
                                            className="donate-bar mt-0"
                                            style={{
                                                height: `calc(12%)`,
                                            }}
                                        >
                                            <div className="first">
                                                <h4>Donate any amount</h4>
                                            </div>
                                            <div className="mid">
                                                <input
                                                    type="text"
                                                    onKeyUp={handelAnyAmount}
                                                    onChange={kumbDonanyamount}
                                                    id="kanyAmount"
                                                    name="kanyAmount"
                                                    placeholder="₹ Amount"
                                                />
                                            </div>
                                            <div className="last">
                                                {/* <a href="#" onClick={donanybtn} class="custom-btn-cls box-hover w-100 h-100">
                          <svg className="me-2" width="24" height="24" viewBox="0 0 512 512">
                            <g id="#000000ff">
                              <path
                                fill="#fff"
                                opacity="1.00"
                                d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                              ></path>
                              <path
                                fill="#fff"
                                opacity="1.00"
                                d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                              ></path>
                            </g>
                          </svg>
                          &nbsp;&nbsp; Donate
                        </a> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="donate-bars-wrap mt-5">
                                    {reset == "1" && Number(makaraAnyamount) + Number(kumbAnyamount) > 0 ? (
                                        <div
                                            className="donate-bar mt-0"
                                        // style={{
                                        //   height: `calc(12%)`,
                                        // }}
                                        >
                                            <div className="first">
                                                <h4>Total Donation Amount</h4>
                                            </div>
                                            <div className="mid">₹ {(Number(makaraAnyamount) + Number(kumbAnyamount)).toLocaleString("en-IN")}</div>
                                            <div className="last">
                                                <a onClick={donanybtn} class="custom-btn-cls box-hover w-100 h-100">
                                                    <svg className="me-2" width="24" height="24" viewBox="0 0 512 512">
                                                        <g id="#000000ff">
                                                            <path
                                                                fill="#fff"
                                                                opacity="1.00"
                                                                d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                                                            ></path>
                                                            <path
                                                                fill="#fff"
                                                                opacity="1.00"
                                                                d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                                                            ></path>
                                                        </g>
                                                    </svg>
                                                    &nbsp;&nbsp; Donate
                                                </a>
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            className="donate-bar mt-0"
                                        // style={{
                                        //   height: `calc(12%)`,
                                        // }}
                                        >
                                            <div className="first">
                                                <h4>Total Donation Amount</h4>
                                            </div>
                                            <div div className="mid">
                                                <span>₹ {reset == "1" ? "0" : sum}</span>
                                            </div>

                                            <div className="last">
                                                <a disabled={isDisabled} onClick={multisevbtn} class="custom-btn-cls box-hover w-100 h-100" style={{ cursor: "pointer" }}>
                                                    <svg className="me-2" width="24" height="24" viewBox="0 0 512 512">
                                                        <g id="#000000ff">
                                                            <path
                                                                fill="#fff"
                                                                opacity="1.00"
                                                                d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                                                            ></path>
                                                            <path
                                                                fill="#fff"
                                                                opacity="1.00"
                                                                d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                                                            ></path>
                                                        </g>
                                                    </svg>
                                                    &nbsp;&nbsp; Donate
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* <div className="col-lg-5 col-xl-4 mb-lg-5">
                  <div className="story-slider">
                    <div className="image-preview mt-5 mt-lg-0">
                      <Splide
                        ref={slider2}
                        options={{
                          type: "fade",
                          rewind: true,
                          pagination: false,
                          arrows: false,
                        }}
                      >
                        {campaign?.galleryImages.map((image, i) => (
                          <SplideSlide key={i} className="image-preview-slide">
                            <figure className="mb-0">
                              <img src={`${process.env.REACT_APP_S3_URL}/uploads/campaigns/gallery-images/${image}`} alt="" />
                            </figure>
                          </SplideSlide>
                        ))}
                      </Splide>
                    </div>
                    <div className="thumbnail-slider-wrap mb-5 mb-lg-0">
                      <Splide
                        ref={slider1}
                        options={{
                          gap: 10,
                          pagination: false,
                          cover: true,
                          arrows: false,
                          perPage: 3,
                          height: 120,
                          heightRatio: 0.5,
                          autoplay: true,
                          speed: 1000,
                          interval: 5000,
                          perMove: 1,
                          type: "loop",
                        }}
                      >
                        {campaign?.galleryImages.map((image, i) => (
                          <SplideSlide key={i} className="thumbnail-slide">
                            <figure className="mb-0 ">
                              <img src={`${process.env.REACT_APP_S3_URL}/uploads/campaigns/gallery-images/${image}`} alt="" />
                            </figure>
                          </SplideSlide>
                        ))}
                      </Splide>
                    </div>
                  </div>
                </div> */}
                            </div>
                        </div>
                    </section>

                    {campaign?.showStatSlider && campaign?.statisticsImages.length > 0 && (
                        <section className="food-life-slider campaign-stats-wrap pt-0 pb-5">
                            <div className="container">
                                <div className="slider-wrapper">
                                    <Splide
                                        ref={foodSliderRef}
                                        className="food-slider"
                                        options={{
                                            perPage: 3,
                                            perMove: 1,
                                            gap: 20,
                                            arrows: false,
                                            pagination: false,
                                            autoplay: true,
                                            speed: 1000,
                                            interval: 8000,
                                            breakpoints: {
                                                576: {
                                                    perPage: 1,
                                                    gap: 20,
                                                },
                                                768: {
                                                    perPage: 2,
                                                    trimSpace: true,
                                                },
                                                992: {
                                                    trimSpace: true,
                                                    perPage: 2,
                                                    gap: 20,
                                                },
                                                1024: {
                                                    trimSpace: true,
                                                    perPage: 3,
                                                    gap: 20,
                                                },
                                                1200: {
                                                    trimSpace: false,
                                                    perPage: 3,
                                                },
                                            },
                                        }}
                                    >
                                        {campaign?.statisticsImages.map((img, i) => (
                                            <SplideSlide key={i}>
                                                <figure className="mb-0">
                                                    <img src={`${process.env.REACT_APP_S3_URL}/uploads/campaigns/statistics-images/${img}`} alt="" />
                                                </figure>
                                            </SplideSlide>
                                        ))}
                                    </Splide>
                                </div>
                            </div>
                            <div className="arrow-wrap">
                                <button className="slider-btn prev box-hover" onClick={() => foodSliderRef.current.splide.go("-1")}>
                                    <FiChevronLeft />
                                </button>
                                <button className="slider-btn next box-hover" onClick={() => foodSliderRef.current.splide.go("+1")}>
                                    <FiChevronRight />
                                </button>
                            </div>
                        </section>
                    )}

                    <section className="campaign-main-sec py-5">
                        <div className="container">
                            <div className="row">
                                {campaign?.eightyGb && (
                                    <div className="col-12">
                                        <div className="campaign-benefits py-4 mb-5">
                                            <div className="campaign-benefits-wrap">
                                                <span>
                                                    <img src="/images/common/bottom.png" alt="" />
                                                </span>
                                                <div className="benefits-content py-5">
                                                    <h4>
                                                        AVAIL 80G BENEFITS ON THE DONATIONS MADE TO ISKCON ATTAPUR (Preaching center- ISKCON HYDERABAD) AS PER THE INCOME TAX ACT 1961 AND RULES MADE THERE UNDER.
                                                    </h4>
                                                    <p>"Tax Exemption order ref no. AAATI0017PF2021901 dated 24/09/2021 valid upto 31/03/2026</p>
                                                </div>
                                                <span>
                                                    <img src="/images/common/top.png" alt="" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {campaign?.hasOtherDonate && (
                                    <div className="col-12">
                                        {/* <div className="row m-0 mb-5">
                      {slug === 'ram' ?



                        <div className="col-lg-4 mb-5 mb-lg-0">
                          <div className="payment-gateways">
                            <div className="gateway-header">
                              <h4 className="mb-0">
                                Donation Through Bank (NEFT/RTGS)
                              </h4>
                            </div>
                            <div className="gateway-content">
                              <div className="key-value">
                                <span>Bank Name -</span> HDFC BANK LTD
                                <button
                                  onClick={() =>
                                    copyToClipBoard(
                                      "HDFC BANK LTD",
                                      "Bank Name Copied"
                                    )
                                  }
                                >
                                  Copy
                                </button>
                              </div>
                              <div className="key-value">
                                <span>Account Name -</span> ISKCON BHIWANDI
                                <button
                                  onClick={() =>
                                    copyToClipBoard(
                                      "ISKCON BHIWANDI",
                                      "Account Name Copied"
                                    )
                                  }
                                >
                                  Copy
                                </button>
                              </div>
                              <div className="key-value">
                                <span>Account Number -</span> 50100224142639
                                <button
                                  onClick={() =>
                                    copyToClipBoard(
                                      "50100224142639",
                                      "Account Number Copied"
                                    )
                                  }
                                >
                                  Copy
                                </button>
                              </div>
                              <div className="key-value">
                                <span>IFSC Code -</span> HDFC0000321
                                <button
                                  onClick={() =>
                                    copyToClipBoard(
                                      "HDFC0000321",
                                      "IFSC Code Copied"
                                    )
                                  }
                                >
                                  Copy
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        :

                        <div className="col-lg-4 mb-5 mb-lg-0">
                          <div className="payment-gateways">
                            <div className="gateway-header">
                              <h4 className="mb-0">
                                Donation Through Bank (NEFT/RTGS)
                              </h4>
                            </div>

                            <div className="gateway-content">
                              <div className="key-value">
                                <span>Bank Name -</span> ICICI Bank
                                <button
                                  onClick={() =>
                                    copyToClipBoard(
                                      "ICICI Bank",
                                      "Bank Name Copied"
                                    )
                                  }
                                >
                                  Copy
                                </button>
                              </div>
                              <div className="key-value">
                                <span>Account Name -</span> ISKCON
                                <button
                                  onClick={() =>
                                    copyToClipBoard(
                                      "ISKCON",
                                      "Account Name Copied"
                                    )
                                  }
                                >
                                  Copy
                                </button>
                              </div>
                              <div className="key-value">
                                <span>Account Number -</span> 036601005061
                                <button
                                  onClick={() =>
                                    copyToClipBoard(
                                      "036601005061",
                                      "Account Number Copied"
                                    )
                                  }
                                >
                                  Copy
                                </button>
                              </div>
                              <div className="key-value">
                                <span>IFSC Code -</span> ICIC0000366
                                <button
                                  onClick={() =>
                                    copyToClipBoard(
                                      "ICIC0000366",
                                      "IFSC Code Copied"
                                    )
                                  }
                                >
                                  Copy
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                      }

                      <div className="col-lg-4 mb-5 mb-lg-0">
                        <div className="payment-gateways">
                          <div className="gateway-header">
                            <h4 className="mb-0">Donate using Paytm</h4>
                          </div>
                          <div className="gateway-content grid">
                            <div className="content">
                              <div className="paytm-logo">
                                <img
                                  src="/images/common/paytm-logo.png"
                                  alt=""
                                />
                                <span>(ISKCON)</span>
                              </div>
                              <div className="key-value">
                                <span>Link-</span> https://paytm.me/Onr-Zsr
                                <button
                                  onClick={() =>
                                    copyToClipBoard(
                                      "https://paytm.me/Onr-Zsr",
                                      "Paytm link Copied"
                                    )
                                  }
                                >
                                  Copy
                                </button>
                              </div>
                              <div className="gateway-btn">
                                <a
                                  href="https://paytm.me/Onr-Zsr"
                                  target="_blank"
                                >
                                  donate now
                                </a>
                              </div>
                            </div>
                            <figure className="mb-0">
                              <img src="/images/common/paytm-qrcode.jpg" alt="" />
                            </figure>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 mb-5 mb-lg-0">
                        <div className="payment-gateways">
                          <div className="gateway-header">
                            <h4 className="mb-0">Donate through UPI</h4>
                          </div>
                          <div className="gateway-content grid">
                            <div className="content">
                              <div className="upi-logo">
                                <img src="/images/common/upi-logo.png" alt="" />
                                <span>(ISKCON)</span>
                              </div>
                              <div className="key-value">
                                <span>UPI ID-</span> iskcon.donate@icici
                                <button
                                  onClick={() =>
                                    copyToClipBoard(
                                      "iskcon.donate@icici",
                                      "UPI ID Copied"
                                    )
                                  }
                                >
                                  Copy
                                </button>
                              </div>
                              <span className="short-note">
                                (Use for Google Pay, BHIM, PhonePe, Paytm and
                                other UPI Apps)
                              </span>
                            </div>
                            <figure className="mb-0">
                              <img src="/images/common/paytm-qrcode.jpg" alt="" />
                            </figure>
                          </div>
                        </div>
                      </div>
                    </div> */}
                                        {campaign?.hasOtherDonate && (
                                            <div className="col-12">
                                                {banksDetails.map((bankDetail) => (
                                                    <div className="row m-0 mb-5">

                                                        <div className="col-lg-6 mb-5 mb-lg-0">
                                                            <div className="payment-gateways">
                                                                <div className="gateway-header">
                                                                    <h4 className="mb-0">Donation Through Bank (NEFT/RTGS)</h4>
                                                                </div>
                                                                <div className="gateway-content">
                                                                    <div className="key-value">
                                                                        <span>Bank Name -</span> {bankDetail.bankName}
                                                                        <button
                                                                            onClick={() => copyToClipBoard(bankDetail.bankName, "Bank Name Copied")}
                                                                        >
                                                                            Copy
                                                                        </button>
                                                                    </div>
                                                                    <div className="key-value">
                                                                        <span>Account Name -</span> {bankDetail.accountName}
                                                                        <button
                                                                            onClick={() => copyToClipBoard(bankDetail.accountName, "Account Name Copied")}
                                                                        >
                                                                            Copy
                                                                        </button>
                                                                    </div>
                                                                    <div className="key-value">
                                                                        <span>Account Number -</span> {bankDetail.accountNumber}
                                                                        <button
                                                                            onClick={() => copyToClipBoard(bankDetail.accountNumber, "Account Number Copied")}
                                                                        >
                                                                            Copy
                                                                        </button>
                                                                    </div>
                                                                    <div className="key-value">
                                                                        <span>IFSC Code -</span> {bankDetail.ifsccode}
                                                                        <button
                                                                            onClick={() => copyToClipBoard(bankDetail.ifsccode, "IFSC Code Copied")}
                                                                        >
                                                                            Copy
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="col-lg-6 mb-5 mb-lg-0">
                                                            <div className="payment-gateways">
                                                                <div className="gateway-header">
                                                                    <h4 className="mb-0">Donate through UPI</h4>
                                                                </div>
                                                                <div className="gateway-content grid">
                                                                    <div className="content">
                                                                        <div className="upi-logo">
                                                                            <img src="/images/common/upi-logo.png" alt="" />
                                                                            <span>(ISKCON)</span>
                                                                        </div>
                                                                        <div className="key-value">
                                                                            <span>UPI ID-</span> {bankDetail.upiId}
                                                                            <button
                                                                                onClick={() =>
                                                                                    copyToClipBoard(
                                                                                        bankDetail.upiId,
                                                                                        "UPI ID Copied"
                                                                                    )
                                                                                }
                                                                            >
                                                                                Copy
                                                                            </button>
                                                                        </div>
                                                                        <span className="short-note">
                                                                            (Use for Google Pay, BHIM, PhonePe, Paytm and
                                                                            other UPI Apps)
                                                                        </span>
                                                                    </div>
                                                                    <figure className="mb-0">
                                                                        <img src={`${process.env.REACT_APP_S3_URL}/uploads/bank/${bankDetail.image}`} alt="" />
                                                                    </figure>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}


                                                {campaign.showArticleDiscription === true && (

                                                    <section class="campaign-heading-sec py-1">
                                                        <div class="container">
                                                            <div class="row">
                                                                <div class="col-lg-12">

                                                                    <div className="welcome-content">

                                                                        <p dangerouslySetInnerHTML={{ __html: campaign?.articleDescription }}></p>

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                )}

                                                {/* <div className="donate-links">
                          <a href="#">Donate through other Payment Gateways</a>
                        </div> */}
                                                {/* <div className="campaign-request mb-5 py-4">
                                                    <p>
                                                        Gentle Request! While doing Paytm/UPI App Payments or
                                                        Bank (NEFT/RTGS) please send us a screenshot along with
                                                        complete address and PAN details on our Whatsapp number
                                                        - <a href="#">+91-7983748776</a> or to our email ID -
                                                        <a href="mailto:support@iskconattapur.com">
                                                            support@iskconattapur.com
                                                        </a>
                                                        . You may also call on this number for other queries.
                                                    </p>
                                                </div> */}
                                                {/* {slug === 'annadaan' || slug === 'rama' || slug === 'makar-sankranti' ? */}
                                                {/* <div className="d-flex justify-content-center mb-5">
                                                    <a
                                                        target="_blank"
                                                        href="https://payments.cashfree.com/forms/donate_now"
                                                        className="box-hover foreign-donation-btn text-white"
                                                    >
                                                        <span className="me-3">
                                                            <img src="/images/common/left-hand.png" alt="" />
                                                        </span>
                                                        <p className="mb-0 text-center">
                                                            Click here to Donate through HDFC Net-Banking or other Payment Gateways
                                                        </p>
                                                        <span className="ms-3">
                                                            <img src="/images/common/right-hand.png" alt="" />
                                                        </span>
                                                    </a>
                                                </div> */}
                                                {/* : ''} */}

                                            </div>
                                        )}


                                        {campaign?.showArticleDiscription && (
                                            <section className="campaign-news">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="news-details">
                                                                <div className="news-details-wrap">
                                                                    <p>{parse(campaign?.articleDescription)}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        )}

                                        <div className="campaign-request mb-5 py-4">
                                            <p>
                                                Gentle Request! While doing Paytm/UPI App Payments or Bank (NEFT/RTGS) please send us a screenshot along with complete address
                                                and PAN details on our Whatsapp number - <a href="#">+91-7983748776</a> or to our email ID -
                                                <a href="mailto:support@iskconattapur.com">
                                                    support@iskconattapur.com
                                                </a>. You may also call on this number for other
                                                queries.
                                            </p>
                                        </div>

                                        <div className="d-flex justify-content-center mb-5">
                                            <a
                                                target="_blank"
                                                href="https://payments.cashfree.com/forms/donate_now"
                                                className="box-hover foreign-donation-btn text-white"
                                            >
                                                <span className="me-3">
                                                    <img src="/images/common/left-hand.png" alt="" />
                                                </span>
                                                <p className="mb-0 text-center">
                                                    Click here to Donate through HDFC Net-Banking or other Payment Gateways
                                                </p>
                                                <span className="ms-3">
                                                    <img src="/images/common/right-hand.png" alt="" />
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                )}
                                {campaign?.hasCsr && (
                                    <div className="col-12">
                                        <div className="donate-links">
                                            <a href="telto:919022873181">
                                                For CSR related query, please contact : Nitai Jivan Das
                                                (+91-9022873181)
                                            </a>
                                        </div>
                                    </div>
                                )}
                                {campaign?.hasForeignDonation && (
                                    <div className="col-12 mt-5">
                                        <div className="d-flex justify-content-center">
                                            <a
                                                target="_blank"
                                                href="https://milaap.org/fundraisers/support-poor-people-in-bhiwandi"
                                                className="box-hover foreign-donation-btn text-white"
                                            >
                                                <span className="me-3">
                                                    <img src="/images/common/left-hand.png" alt="" />
                                                </span>
                                                For Foreign Donation, Click Here
                                                <span className="ms-3">
                                                    <img src="/images/common/right-hand.png" alt="" />
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>

                    {campaign?.showTestimonial && campaign?.testimonials.length > 0 && (
                        <section className="campaign-review-sec">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8 mx-auto">
                                        <h2 className="pb-2">
                                            KIND HEARTED <span>PEOPLE SAY</span>
                                        </h2>
                                    </div>
                                </div>

                                <Splide
                                    ref={ref}
                                    options={{
                                        perPage: campaign?.testimonials.length >= 3 ? 3 : campaign?.testimonials.length,
                                        perMove: 1,
                                        type: "single",
                                        arrows: false,
                                        pagination: false,
                                        autoplay: true,
                                        speed: 1000,
                                        interval: 4000,
                                        type: "loop",
                                        breakpoints: {
                                            991: {
                                                perPage: campaign?.testimonials.length >= 2 ? 2 : campaign?.testimonials.length,
                                            },
                                            576: {
                                                perPage: 1,
                                            },
                                        },
                                    }}
                                >
                                    {campaign?.testimonials?.map((test) => (
                                        <SplideSlide key={test._id}>
                                            <div className="campaign-review">
                                                <figure>
                                                    <img src={`${process.env.REACT_APP_S3_URL}/uploads/campaigns/testimonials-profile/${test.profile}`} alt="" />
                                                </figure>
                                                <div className="profile-name">
                                                    <h5>{test?.name}</h5>
                                                    <p>{test?.designation}</p>
                                                </div>
                                                <div className="profile-review">
                                                    <h6>{test.peopleCount}</h6>
                                                    <p>{test?.description?.length > 200 ? test.description.substring(0, 200) : test.description}</p>
                                                    {test?.description?.length > 200 && (
                                                        <button onClick={() => handleReadMore(test)} className="custom-btn-cls box-hover">
                                                            Read More
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </SplideSlide>
                                    ))}
                                </Splide>
                            </div>
                            <div className="arrow-wrap">
                                <button className="slider-btn prev box-hover" onClick={() => ref.current.splide.go("-1")}>
                                    <FiChevronLeft />
                                </button>
                                <button className="slider-btn next box-hover" onClick={() => ref.current.splide.go("+1")}>
                                    <FiChevronRight />
                                </button>
                            </div>
                        </section>
                    )}

                    {campaign?.showNews && (
                        <section className="campaign-news">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8 mx-auto">
                                        <div className="dual-heading center">
                                            <h2>
                                                ISKCON <span>In The news</span>
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-lg-10 mx-auto">
                                        <div className="live-video-wrap">
                                            <iframe src={campaign?.newsLink} allowFullScreen="allowfullscreen"></iframe>
                                            <div className="news-details">
                                                <div className="news-details-wrap">
                                                    <h4>{campaign?.newsTitle}</h4>
                                                    <p>{campaign?.newsDescription}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}

                    {campaign?.showArticle && (
                        <section className="campaign-articles">
                            <div className="container">
                                <div className="campaign-articles-wrap">
                                    <Splide
                                        ref={articleRef}
                                        options={{
                                            perPage: 3,
                                            perMove: 1,
                                            type: "loop",
                                            arrows: false,
                                            pagination: false,
                                            autoplay: true,
                                            speed: 1000,
                                            interval: 4000,
                                            gap: "2rem",
                                            breakpoints: {
                                                991: {
                                                    perPage: 2,
                                                },
                                                576: {
                                                    perPage: 1,
                                                },
                                            },
                                        }}
                                    >
                                        {campaign?.campaignArticles.map((art, i) => (
                                            <SplideSlide key={i}>
                                                <figure className="mb-0">
                                                    <img src={`${process.env.REACT_APP_S3_URL}/uploads/campaigns/campaign-articles/${art}`} alt="" />
                                                </figure>
                                            </SplideSlide>
                                        ))}
                                    </Splide>
                                </div>
                            </div>
                            <div className="arrow-wrap">
                                <button className="slider-btn prev box-hover" onClick={() => articleRef.current.splide.go("-1")}>
                                    <FiChevronLeft />
                                </button>
                                <button className="slider-btn next box-hover" onClick={() => articleRef.current.splide.go("+1")}>
                                    <FiChevronRight />
                                </button>
                            </div>
                        </section>
                    )}

                    {campaign?.hasSupportButton && (
                        <section className={`campaign-support pt-0`}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-10 mx-auto">
                                        <div className="dual-heading center">
                                            <h2>
                                                <span>lets come together to</span> support people
                                                <span> in need</span>
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="support-btn-wrap">
                                    <button onClick={handleScroll} className="custom-btn-cls box-hover">
                                        support now
                                    </button>
                                    <figure className="mb-0">
                                        <img src="/images/common/arrow-down.png" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </section>
                    )}
                </>
            )}

            <GoToTop top={top} />

            {popUpContent && (
                <Modal contentClassName="about-popup-content" centered show={readMore} onHide={() => setReadMore(false)}>
                    <div className="modal-wrap-read content-modal">
                        <div className="pop-up-form read">
                            <div className="pop-up-top">
                                <div className="heading">
                                    <h2 className="head-2">{popUpContent.name}</h2>
                                </div>
                                <button className="btn close-btn" onClick={() => setReadMore(false)}>
                                    <svg
                                        className="close-svg"
                                        stroke="currentColor"
                                        fill="currentColor"
                                        strokeWidth="0"
                                        viewBox="0 0 16 16"
                                        height="1em"
                                        width="1em"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M7.116 8l-4.558 4.558.884.884L8 8.884l4.558 4.558.884-.884L8.884 8l4.558-4.558-.884-.884L8 7.116 3.442 2.558l-.884.884L7.116 8z"
                                        ></path>
                                    </svg>
                                </button>
                                <figure className="hare-krishna-logo-fig">
                                    <img src="/images/modal/hare-krishna-logo.svg" alt="" />
                                </figure>
                            </div>
                            <p>{popUpContent.description}</p>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default MsKmCampaign;
